export const IS_OPEN = 'IS_OPEN';
export const ADD_ID_TO_MODAL = 'ADD_ID_TO_MODAL';
